import { reduceFilters } from './FilteringUtils/filterItemUtils'
import {
  FilterItem,
  Filter,
  FilterCategory,
  ApplicableFilter,
} from '../services/types/services'

export const getIsFilterApplied = (
  filters: FilterItem[],
  key: string,
  filterSelectionState = true,
): boolean => {
  const recursiveFlatMapNbas = (
    allFilters: (ApplicableFilter | FilterCategory)[],
  ): Filter[] => {
    if (allFilters.length === 0) {
      return []
    }

    const current = allFilters.filter(
      x =>
        x.__typename === 'Filter' ||
        x.__typename === 'FilterCategory' ||
        x.__typename === 'FilterToggle' ||
        x.__typename === 'FilterInvertedToggle',
    )
    const currentChildren = allFilters.flatMap(x =>
      x.__typename === 'FilterCategory'
        ? recursiveFlatMapNbas(reduceFilters(x.children))
        : [],
    )

    return [...current, ...currentChildren] as Filter[]
  }

  const appliedFilter = [
    ...new Set(recursiveFlatMapNbas(reduceFilters(filters))),
  ].filter(x => x.id === key && x.isSelected === filterSelectionState)

  return appliedFilter.length > 0
}
